import React from 'react'

const NOTICE_URL = 'https://orsol.notion.site/38390115bc8680408028ee191c05be49'

type ServiceTerminationNoticeProps = {
  fixed?: boolean
}

const ServiceTerminationNotice: React.FC<ServiceTerminationNoticeProps> = ({ fixed = false }) => {
  return (
    <div className={`service-termination-notice${fixed ? ' service-termination-notice--fixed' : ''}`}>
      <strong>【お知らせ】</strong>
      スグニーは2026年6月30日（火）をもちましてサービスを終了いたします。詳しくは
      <a href={NOTICE_URL} target="_blank" rel="noopener noreferrer">
        こちら
      </a>
      →
    </div>
  )
}

export default ServiceTerminationNotice
